import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles, THEME_VARIANTS } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  // Reskin: every ExpandableCard (sidebar Type and Discounts, policy Discounts) is its screen's highlight card.
  container: {
    backgroundColor: theme.colorPalette.green_90,
    ...reskinStyles(theme, theme.cardStyles.highlight)
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(4, 6)
  },
  // Classic keeps its own badge green; the reskin uses Badge's outlined label. `&&` outranks Badge's own sheet.
  badge: theme.themeVariant === THEME_VARIANTS.RESKIN ? {} : { '&&': { backgroundColor: theme.colorPalette.green_80 } },
  right: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  iconButtonRoot: {
    color: theme.colors.action_icon,
    padding: 0
  },
  iconButtonLabel: {
    height: 32,
    width: 32
  },
  icon: {
    height: 32,
    transition: 'transform var(--motion-duration-close, 0ms) var(--motion-ease-out, ease-out)'
  },
  collapse: {
    transform: 'rotate(180deg)'
  }
});

export default makeStyles(styles);
